import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* undoSettleWithSavings(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_REQUEST
    })

    let res: any;
    if (action.payload?.chargeId) {
      res = yield call(Http.delete, `charges/${action.payload.chargeId}/undo-settle-with-savings`, {});
    } else {
      res = yield call(Http.delete, `payments/${action.payload?.paymentId}/undo-settle-with-savings`, {});
    }
    yield put({
      type: Constants.GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_SUCCESS
    })
    
    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchUndoSettleWithSavings() {
  yield takeEvery(Constants.GLOBAL_UNDO_SETTLE_WITH_SAVINGS_ACCOUNT_START, undoSettleWithSavings);
}
